import { useParams } from "react-router-dom";
export function useIsPageVersionControlled() {
    const params = useParams();
    return Object.keys(params).includes("branchName");
}
